import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';

import { AuthStore } from '../store';

export const adminGuard: CanActivateFn = async () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  if (!authStore.user()) {
    await authStore.getSession();
  }

  const user = authStore.user();
  if (user?.role === 'admin') {
    return true;
  }

  return router.createUrlTree(['/']);
};
